import Cookies from 'js-cookie';
import getUserNewsletterSubscriptions from 'lib/personalizationApi/getUserNewsletterSubscriptions';

export const getOptimizelyAttributes = async () => {
  const attributes: Record<string, any> = {};
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent;
    if (/Mobi|Android/i.test(userAgent)) {
      attributes.deviceType = 'Mobile';
    } else if (/Tablet|iPad/i.test(userAgent)) {
      attributes.deviceType = 'Tablet';
    } else {
      attributes.deviceType = 'Desktop';
    }

    if (userAgent.indexOf('Chrome') > -1) {
      attributes.browserType = 'Chrome';
    } else if (userAgent.indexOf('Firefox') > -1) {
      attributes.browserType = 'Firefox';
    } else if (userAgent.indexOf('Safari') > -1) {
      attributes.browserType = 'Safari';
    } else if (userAgent.indexOf('Edge') > -1) {
      attributes.browserType = 'Edge';
    } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
      attributes.browserType = 'IE';
    } else {
      attributes.browserType = 'Unknown';
    }

    // UTM Parameters
    const urlParams = new URLSearchParams(window.location.search);
    attributes.utm = '';
    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        attributes.utm += `${key}=${value}&`;
      }
    });
    // Remove trailing '&' if exists
    if (attributes.utm.endsWith('&')) {
      attributes.utm = attributes.utm.slice(0, -1);
    }
  }

  // referer
  const referer = document?.referrer || '';
  attributes.referer = referer ? new URL(referer).hostname : 'Direct';
  // Login Status
  attributes.isLoggedIn = !!Cookies.get('pianoUid');
  // Fortune Email Subscriber
  const userEmail = Cookies.get('userEmail');
  if (attributes.isLoggedIn && userEmail) {
    try {
      const subscriptions = await getUserNewsletterSubscriptions(userEmail);
      attributes.isFortuneEmailSubscriber = subscriptions && subscriptions.length > 0;
    } catch {
      attributes.isFortuneEmailSubscriber = false;
    }
  } else {
    attributes.isFortuneEmailSubscriber = false;
  }

  attributes.geography = Cookies.get('__pil') || 'Unknown';

  return attributes;
};
